export default (Vue) => {
    Vue.directive('priceMin', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                val = val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入三个小数
                switch (binding.value.correctTo) {
                    case '元':
                        val = val.replace(/[^\d]/g, '') //输入正整数
                        break
                    case '角':
                        val = val.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') //只能输入1个小数
                        break
                    case '分':
                        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入2个小数
                        break
                    default:
                        break
                }
                ele.value = val;
                binding.value.setPriceMin(ele.value)
            }
        },
    });
    Vue.directive('priceMax', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                val = val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入三个小数
                switch (binding.value.correctTo) {
                    case '元':
                        val = val.replace(/[^\d]/g, '') //输入正整数
                        break
                    case '角':
                        val = val.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') //只能输入1个小数

                        break
                    case '分':
                        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入2个小数
                        break
                    default:
                        break
                }
                ele.value = val;
                binding.value.setPriceMax(ele.value)
            }
        },
    });
    Vue.directive('price', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                val = val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入三个小数
                switch (binding.value.correctTo) {
                    case '元':
                        val = val.replace(/[^\d]/g, '') //输入正整数
                        break
                    case '角':
                        val = val.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') //只能输入1个小数
                        break
                    case '分':
                        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入2个小数
                        break
                    default:
                        break
                }
                ele.value = val;
                binding.value.setPrice(ele.value)
            }
        },
    });
    Vue.directive('num', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(/[^\d]/g, '') //输入正整数
                ele.value = val;
                // binding.value.setNum(ele.value)
            }
        },
    });
     Vue.directive('dotNum', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入2个小数
                ele.value = val;
                binding.value.setNum(ele.value)
            }
        },
    });
    Vue.directive('numStart', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                // val = val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入三个小数
                if (binding.value.decimal) {
                    let decimal = binding.value.decimal
                    let regStr = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${decimal}}).*$`)
                    // let resVal =regStr.test(val)
                    val = val.replace(regStr, '$1$2.$3'); //只能输入三个小数
                } else {
                    val = val.replace(/[^\d]/g, '') //输入正整数
                }
                ele.value = val;
                binding.value.setStartValue(ele.value)
            }
        },
    });
    Vue.directive('numEnd', {
        componentUpdated: function (el, binding) {
            let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.oninput = function () {
                let val = ele.value;
                val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
                val = val.replace(/^\./g, ""); //验证第一个字符是数字
                val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
                val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                // val = val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入三个小数
                if (binding.value.decimal) {
                    let decimal = binding.value.decimal
                    let regStr = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${decimal}}).*$`)
                    // let resVal =regStr.test(val)
                    val = val.replace(regStr, '$1$2.$3'); //只能输入三个小数
                } else {
                    val = val.replace(/[^\d]/g, '') //输入正整数
                }
                ele.value = val;
                binding.value.setEndValue(ele.value)
            }
        },
    });
    Vue.directive('enterNumber', { //全局方法  限制input输入框只能输入纯数字 组件中调用如（<el-input v-enter-number v-model="number" ></el-input>）
        inserted: function (el) {
            el.addEventListener("keypress", function (e) {
                e = e || window.event;
                let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
                let re = /\d/;
                if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    } else {
                        e.returnValue = false;
                    }
                }
            });
        }
    });
    Vue.directive('loadmore', {
        inserted(el, binding) {
            const SELECTDOWN_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
            SELECTDOWN_DOM.addEventListener('scroll', function() {
                const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (CONDITION) {
                    binding.value();
                }
            });
        }
    });
}